import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, AuthenticationService } from '../_services/index';

@Component({
  selector: 'app-confirm-password',
  templateUrl: './confirm-password.component.html',
  styleUrls: ['./confirm-password.component.css']
})
export class ConfirmPasswordComponent implements OnInit {

  loading = false;
  uid : string;
  token : string;
  new_password : string;
  retype_password : string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService) {
      this.route.params.subscribe( params => { this.uid=params.uid; this.token=params.token} );
     }

  ngOnInit() {
  }

  confirmPass() {
    this.loading = true;
    this.authenticationService.confirmPass(this.uid, this.token, this.new_password, this.retype_password)
        .subscribe(
            data => {
              this.loading = false;
              this.router.navigate(['/login']);
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
  }
}



// WEBPACK FOOTER //
// ./src/app/confirm-password/confirm-password.component.ts